import { User } from '@/models/User';
import { birthday } from '@/support/Date';
export class Supervisor extends User {
    constructor() {
        super(...arguments);
        this.$name = 'Supervisor';
        this.$fillable = ['avatar', 'name', 'first_name', 'middle_name', 'last_name', 'dob', 'email', 'password', 'school', 'supervisor', 'phone', 'roles', 'parnassys_id'];
        this.filters = {
            role: 'internal-supervisor',
        };
    }
    setDobAttribute(value) {
        this.age = birthday(value);
        return value;
    }
    url() {
        return '/supervisors/' + this.id;
    }
}
